import axios from 'axios'

const SET_CATEGORIES = 'SET_CATEGORIES'
const SET_CONCRETES = 'SET_CONCRETES'
const SET_AGGREGATES = 'SET_AGGREGATES'
const SET_STEELS = 'SET_STEELS'
const SET_TIMESTAMP = 'SET_TIMESTAMP'

/**
 * Vuex state for category module
 * @type {Object}
 */
const state = {
    categories: [],
    concretes: [],
    aggregates: [],
    steels: [],
    timestamp: null,
}

/**
 * Vuex mutations for category module
 * @type {Object}
 */
const mutations = {
    [SET_CATEGORIES]: (state, payload) => {
        state.categories = payload
    },

    [SET_CONCRETES]: (state, payload) => {
        state.concretes = payload
    },

    [SET_AGGREGATES]: (state, payload) => {
        state.aggregates = payload
    },

    [SET_STEELS]: (state, payload) => {
        state.steels = payload
    },

    [SET_TIMESTAMP]: (state, payload) => {
        state.timestamp = payload
    },
}

/**
 * Vuex actions for category module
 * @type {Object}
 */
const actions = {
    async fetchCategories({ commit, dispatch }) {
        dispatch('wait/start', 'fetchCategories', { root: true })

        const { data } = await axios.get('/api/categories')
        commit(SET_CATEGORIES, data.categories)
        commit(SET_TIMESTAMP, data.timestamp)

        dispatch('wait/end', 'fetchCategories', { root: true })
        return data
    },
}

/**
 * Vuex getters for product module
 * @type {Object}
 */
const getters = {
    categories: (state) => state.categories,
    concretes: (state) =>
        state.categories.find((category) => category.alias === 'concrete')
            .products,
    pumps: (state) =>
        state.categories.find((category) => category.alias === 'pump')
            .products,
    aggregates: (state) =>
        state.categories.find((category) => category.alias === 'aggregate')
            .subcategories,
    steels: (state) =>
        state.categories.find((category) => category.alias === 'steel')
            .subcategories,
    categories_timestamp: (state) => state.timestamp,
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
